export const ISendDidDismissEventUseCaseType = Symbol('ISendDidDismissEventUseCase');
